<!--
 * @Description: 新增活码页面
 * @Author: mdb
 * @Date: 2023-04-17 16:07:46
 * @LastEditTime: 2023-04-19 16:34:26
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <DetailForm type="add" title="新增活码" paramCode="zbu_source_channel_fbu" subdomain="fbu" />
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import DetailForm from '@/views/marketing/marketingManage/activityCode/components/DetailForm.vue'
</script>
<script lang="ts">
export default { name: 'DcCosFbuActivityCodeAdd' }
</script>

<style scoped></style>
